import(/* webpackMode: "eager" */ "/app/landing/src/app/about/page.tsx");
